<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_ix"></a>For Kenny Lindsay – a great writer and old friend</p>
<div class="page-break">
<p class="image"><a id="page_x"></a><img alt="Illustration" src="images/f000x-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?032b7c53